import { profileUrl, setImgPath, noImage } from '../../utils/image';

const VueImageFilter = {
    install(Vue) {
        Vue.filter('profileUrl', profileUrl);
        Vue.filter('setImgPath', setImgPath);
        Vue.filter('noImage', noImage);
    }
};

export default VueImageFilter;
